const striverData = [
  {
    topicName: "Array",
    position: 0,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Array",
        Problem: "Set Matrix Zeroes",
        Done: false,
        URL: "https://leetcode.com/problems/set-matrix-zeroes/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Pascal’s Triangle",
        Done: false,
        URL: "https://leetcode.com/problems/pascals-triangle/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Next Permutation",
        Done: false,
        URL: "https://leetcode.com/problems/next-permutation/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Kadane’s Algorithm",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-subarray/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Sort an array of 0’s 1’s 2’s",
        Done: false,
        URL: "https://leetcode.com/problems/sort-colors/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Stock buy and Sell",
        Done: false,
        URL: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Rotate Matrix",
        Done: false,
        URL: "https://leetcode.com/problems/rotate-image/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Merge Overlapping Subintervals",
        Done: false,
        URL: "https://leetcode.com/problems/merge-intervals/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Merge two sorted Arrays without extra space",
        Done: false,
        URL: "https://leetcode.com/problems/merge-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Find the duplicate in an array of N+1 integers.",
        Done: false,
        URL: "https://leetcode.com/problems/find-the-duplicate-number/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Repeat and Missing Number",
        Done: false,
        URL: "https://www.interviewbit.com/problems/repeat-and-missing-number-array/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Array",
        Problem: "Inversion of Array (Pre-req: Merge Sort)",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/count-inversions_615",
        Platform: "codingninjas",
      },
      {
        Topic: "Array",
        Problem: "Search in a 2d Matrix",
        Done: false,
        URL: "https://leetcode.com/problems/search-a-2d-matrix/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Pow(X,n)",
        Done: false,
        URL: "https://leetcode.com/problems/powx-n/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Majority Element (>N/2 times)",
        Done: false,
        URL: "https://leetcode.com/problems/majority-element/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Majority Element (>N/3 times)",
        Done: false,
        URL: "https://leetcode.com/problems/majority-element-ii/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Grid Unique Paths",
        Done: false,
        URL: "https://leetcode.com/problems/unique-paths/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Reverse Pairs",
        Done: false,
        URL: "https://leetcode.com/problems/reverse-pairs/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "2-Sum-Problem",
        Done: false,
        URL: "https://leetcode.com/problems/two-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "4-Sum-Problem",
        Done: false,
        URL: "https://leetcode.com/problems/4sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Longest Consecutive Sequence",
        Done: false,
        URL: "https://leetcode.com/problems/longest-consecutive-sequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Largest Subarray with 0 sum",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/largest-subarray-with-0-sum/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Array",
        Problem: "Count number of subarrays with given Xor K",
        Done: false,
        URL: "https://www.interviewbit.com/problems/subarray-with-given-xor/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Array",
        Problem: "Longest Substring without repeat",
        Done: false,
        URL: "https://leetcode.com/problems/longest-substring-without-repeating-characters/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "3 sum",
        Done: false,
        URL: "https://leetcode.com/problems/3sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Trapping rainwater",
        Done: false,
        URL: "https://leetcode.com/problems/trapping-rain-water/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Remove Duplicate from Sorted array",
        Done: false,
        URL: "https://leetcode.com/problems/remove-duplicates-from-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Array",
        Problem: "Max consecutive ones",
        Done: false,
        URL: "https://leetcode.com/problems/max-consecutive-ones/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "Linked List",
    position: 1,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "LinkedList",
        Problem: "Reverse a LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/reverse-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Find the middle of LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/middle-of-the-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Merge two sorted Linked List (use method used in mergeSort)",
        Done: false,
        URL: "https://leetcode.com/problems/merge-two-sorted-lists/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Remove N-th node from back of LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/remove-nth-node-from-end-of-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Add two numbers as LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/add-two-numbers/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Delete a given Node when a node is given.(0(1) solution)",
        Done: false,
        URL: "https://leetcode.com/problems/delete-node-in-a-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Find intersection point of Y LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/intersection-of-two-linked-lists/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Detect a cycle in Linked List",
        Done: false,
        URL: "https://leetcode.com/problems/linked-list-cycle/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Reverse a LinkedList in groups of size k",
        Done: false,
        URL: "https://leetcode.com/problems/reverse-nodes-in-k-group/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Check if a LinkedList is palindrome or not",
        Done: false,
        URL: "https://leetcode.com/problems/palindrome-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Find the starting point of the Loop of LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/linked-list-cycle-ii/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Flattening of a LinkedList",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/flattening-a-linked-list/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Rotate a LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/rotate-list/description/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Clone a Linked List with random and next pointer",
        Done: false,
        URL: "https://leetcode.com/problems/copy-list-with-random-pointer/",
        Platform: "leecode",
      },
    ],
  },
  {
    topicName: "String",
    position: 2,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "String",
        Problem: "Reverse Words in a String",
        Done: false,
        URL: "https://leetcode.com/problems/reverse-words-in-a-string/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Longest Palindrome in a string",
        Done: false,
        URL: "https://leetcode.com/problems/longest-palindromic-substring/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Roman Number to Integer and vice versa",
        Done: false,
        URL: "https://leetcode.com/problems/roman-to-integer/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Implement ATOI/STRSTR",
        Done: false,
        URL: "https://leetcode.com/problems/string-to-integer-atoi/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Longest Common Prefix",
        Done: false,
        URL: "https://leetcode.com/problems/longest-common-prefix/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Rabin Karp",
        Done: false,
        URL: "https://leetcode.com/problems/repeated-string-match/discuss/416144/Rabin-Karp-algorithm-C%2B%2B-implementation",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Z-Function",
        Done: false,
        URL: "https://leetcode.com/problems/implement-strstr/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "KMP algo / LPS(pi) array",
        Done: false,
        URL: "https://leetcode.com/problems/implement-strstr/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem:
          "Minimum characters needed to be inserted in the beginning to make it palindromic",
        Done: false,
        URL: "https://www.interviewbit.com/problems/minimum-characters-required-to-make-a-string-palindromic/",
        Platform: "Interviewbit",
      },
      {
        Topic: "String",
        Problem: "Check for Anagrams",
        Done: false,
        URL: "https://leetcode.com/problems/valid-anagram/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Count and Say",
        Done: false,
        URL: "https://leetcode.com/problems/count-and-say/",
        Platform: "leetcode",
      },
      {
        Topic: "String",
        Problem: "Compare version numbers",
        Done: false,
        URL: "https://leetcode.com/problems/compare-version-numbers/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "Greedy Algorithm",
    position: 3,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Greedy Algorithm",
        Problem: "N meetings in one room",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/n-meetings-in-one-room-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy Algorithm",
        Problem: "Minimum number of platforms required for a railway",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/minimum-platforms-1587115620/1#",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy Algorithm",
        Problem: "Job sequencing Problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/job-sequencing-problem-1587115620/1#",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy Algorithm",
        Problem: "Fractional Knapsack Problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/fractional-knapsack-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy Algorithm",
        Problem: "Greedy algorithm to find minimum number of coins",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-minimum-number-of-coins-that-make-a-change/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy Algorithm",
        Problem: "Activity Selection (it is the same as N meeting in one room)",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/n-meetings-in-one-room-1587115620/1",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Binary Trees",
    position: 4,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Binary Trees",
        Problem: "Inorder Traversal / Morris Inorder Traversal",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-inorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Preorder Traversal / Morris Preorder Traversal",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-preorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Postorder Traversal",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-postorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "LeftView Of Binary Tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Bottom View of Binary Tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Top View of Binary Tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Preorder inorder postorder in a single traversal",
        Done: false,
        URL: "https://bit.ly/3rlXpTX",
        Platform: "codingninjas",
      },
      {
        Topic: "Binary Trees",
        Problem: "Vertical order traversal",
        Done: false,
        URL: "https://leetcode.com/problems/vertical-order-traversal-of-a-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Root to node path in a Binary Tree",
        Done: false,
        URL: "https://www.interviewbit.com/problems/path-to-given-node/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Binary Trees",
        Problem: "Max width of a Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-width-of-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Level order Traversal / Level order traversal in spiral form",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-level-order-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Height of a Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-depth-of-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Diameter of Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/diameter-of-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check if the Binary tree is height-balanced or not",
        Done: false,
        URL: "https://leetcode.com/problems/balanced-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "LCA in Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check if two trees are identical or not",
        Done: false,
        URL: "https://leetcode.com/problems/same-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Zig Zag Traversal of Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-zigzag-level-order-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Boundary Traversal of Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/boundary-of-binary-tree/#",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Maximum path sum",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-maximum-path-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Construct Binary Tree from inorder and preorder",
        Done: false,
        URL: "https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Construct Binary Tree from Inorder and Postorder",
        Done: false,
        URL: "https://leetcode.com/problems/construct-binary-tree-from-inorder-and-postorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Symmetric Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/symmetric-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Flatten Binary Tree to LinkedList",
        Done: false,
        URL: "https://leetcode.com/problems/flatten-binary-tree-to-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check if Binary Tree is the mirror of itself or not",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/mirror-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check for Children Sum Property",
        Done: false,
        URL: "https://bit.ly/33yExIQ",
        Platform: "codingninjas",
      },
      {
        Topic: "Binary Trees",
        Problem: "Binary Tree to Double Linked List",
        Done: false,
        URL: "https://leetcode.com/problems/flatten-binary-tree-to-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Find median in a stream of running integers",
        Done: false,
        URL: "https://leetcode.com/problems/find-median-from-data-stream/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "K-th largest element in a stream",
        Done: false,
        URL: "https://leetcode.com/problems/kth-largest-element-in-a-stream/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Distinct numbers in Window",
        Done: false,
        URL: "https://www.interviewbit.com/problems/distinct-numbers-in-window/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Binary Trees",
        Problem: "K-th largest element in an unsorted array",
        Done: false,
        URL: "https://leetcode.com/problems/kth-largest-element-in-an-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Flood-fill Algorithm",
        Done: false,
        URL: "https://leetcode.com/problems/flood-fill/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "BST",
    position: 5,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Binary Search Trees",
        Problem: "Populate Next Right pointers of Tree",
        Done: false,
        URL: "https://leetcode.com/problems/populating-next-right-pointers-in-each-node/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Search given Key in BST",
        Done: false,
        URL: "https://leetcode.com/problems/search-in-a-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Construct BST from given keys",
        Done: false,
        URL: "https://leetcode.com/problems/convert-sorted-array-to-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Construct BST from preorder traversal",
        Done: false,
        URL: "https://leetcode.com/problems/construct-binary-search-tree-from-preorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Check is a BT is BST or not",
        Done: false,
        URL: "https://leetcode.com/problems/validate-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Find LCA of two nodes in BST",
        Done: false,
        URL: "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem:
          "Find the inorder predecessor/successor of a given Key in BST.",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Floor in a BST",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/floor-from-bst_920457?source=youtube&campaign=Striver_Tree_Videos&utm_source=youtube&utm_medium=affiliate&utm_campaign=Striver_Tree_Videos",
        Platform: "codingninjas",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Ceil in a BST",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/ceil-from-bst_920464?source=youtube&campaign=Striver_Tree_Videos&utm_source=youtube&utm_medium=affiliate&utm_campaign=Striver_Tree_Videos",
        Platform: "codingninjas",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Find K-th smallest element in BST",
        Done: false,
        URL: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Find K-th largest element in BST",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Find a pair with a given sum in BST",
        Done: false,
        URL: "https://leetcode.com/problems/two-sum-iv-input-is-a-bst/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "BST iterator",
        Done: false,
        URL: "https://leetcode.com/problems/binary-search-tree-iterator/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Size of the largest BST in a Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-sum-bst-in-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Serialize and deserialize Binary Tree",
        Done: false,
        URL: "https://leetcode.com/problems/serialize-and-deserialize-binary-tree/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "Binary Search",
    position: 6,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Binary Search",
        Problem: "The N-th root of an integer",
        Done: false,
        URL: "https://bit.ly/3rj7Ib1",
        Platform: "codingninjas",
      },
      {
        Topic: "Binary Search",
        Problem: "Matrix Median",
        Done: false,
        URL: "https://www.interviewbit.com/problems/matrix-median/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Binary Search",
        Problem:
          "Find the element that appears once in a sorted array, and the rest element appears twice (Binary search)",
        Done: false,
        URL: "https://leetcode.com/problems/single-element-in-a-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search",
        Problem:
          "Search element in a sorted and rotated array/ find pivot where it is rotated",
        Done: false,
        URL: "https://leetcode.com/problems/search-in-rotated-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search",
        Problem: "Median of 2 sorted arrays",
        Done: false,
        URL: "https://leetcode.com/problems/median-of-two-sorted-arrays/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search",
        Problem: "K-th element of two sorted arrays",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/k-th-element-of-two-sorted-array1317/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search",
        Problem: "Allocate Minimum Number of Pages",
        Done: false,
        URL: "https://www.interviewbit.com/problems/allocate-books/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Binary Search",
        Problem: "Aggressive Cows",
        Done: false,
        URL: "https://www.spoj.com/problems/AGGRCOW/",
        Platform: "spoj",
      },
    ],
  },
  {
    topicName: "Recursion & BackTracking",
    position: 7,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Recursion & BackTracking",
        Problem: "Subset Sums",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/subset-sums2234/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Subset-II",
        Done: false,
        URL: "https://leetcode.com/problems/subsets-ii/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Combination sum-1",
        Done: false,
        URL: "https://leetcode.com/problems/combination-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Combination sum-2",
        Done: false,
        URL: "https://leetcode.com/problems/combination-sum-ii/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Palindrome Partitioning",
        Done: false,
        URL: "https://leetcode.com/problems/palindrome-partitioning/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "K-th permutation Sequence",
        Done: false,
        URL: "https://leetcode.com/problems/permutation-sequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Print all permutations of a string/array",
        Done: false,
        URL: "https://leetcode.com/problems/permutations/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "N queens Problem",
        Done: false,
        URL: "https://leetcode.com/problems/n-queens/1",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Sudoku Solver",
        Done: false,
        URL: "https://leetcode.com/problems/sudoku-solver/",
        Platform: "leetcode",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "M coloring Problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/m-coloring-problem-1587115620/1#",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Rat in a Maze",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Recursion & BackTracking",
        Problem: "Word Break (print all ways)",
        Done: false,
        URL: "https://bit.ly/3FxgW92",
        Platform: "codingninjas",
      },
    ],
  },
  {
    topicName: "Stacks & Queues",
    position: 8,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Stacks & Queues",
        Problem: "Implement Stack Using Arrays",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/stack-implementation-using-array_3210209",
        Platform: "codingninjas",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement Queue Using Arrays",
        Done: false,
        URL: "https://bit.ly/3KbIjIW",
        Platform: "codingninjas",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement Stack using Queue (using single queue)",
        Done: false,
        URL: "https://leetcode.com/problems/implement-stack-using-queues/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement Queue using Stack (0(1) amortized method)",
        Done: false,
        URL: "https://leetcode.com/problems/implement-queue-using-stacks/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Check for balanced parentheses",
        Done: false,
        URL: "https://leetcode.com/problems/valid-parentheses/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Next Greater Element",
        Done: false,
        URL: "https://leetcode.com/problems/next-greater-element-ii/description/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Sort a Stack",
        Done: false,
        URL: "https://bit.ly/3nptF7k",
        Platform: "codingninjas",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Next Smaller Element",
        Done: false,
        URL: "https://www.interviewbit.com/problems/nearest-smaller-element/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "LRU cache (IMPORTANT)",
        Done: false,
        URL: "https://leetcode.com/problems/lru-cache/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "LFU Cache",
        Done: false,
        URL: "https://leetcode.com/problems/lfu-cache/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Largest rectangle in a histogram",
        Done: false,
        URL: "https://leetcode.com/problems/largest-rectangle-in-histogram/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Sliding Window maximum",
        Done: false,
        URL: "https://leetcode.com/problems/sliding-window-maximum/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement Min Stack",
        Done: false,
        URL: "https://leetcode.com/problems/min-stack/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Rotten Orange (Using BFS)",
        Done: false,
        URL: "https://leetcode.com/problems/rotting-oranges/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Stock Span Problem",
        Done: false,
        URL: "https://leetcode.com/problems/online-stock-span/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Find the maximum of minimums of every window size",
        Done: false,
        URL: "https://bit.ly/3zUYLZz",
        Platform: "codingninjas",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "The Celebrity Problem",
        Done: false,
        URL: "https://bit.ly/3GuImxi",
        Platform: "codingninjas",
      },
    ],
  },
  {
    topicName: "Heap",
    position: 9,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Heap",
        Problem: "Max heap, Min Heap Implementation (Only for interviews)",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/min-heap_4691801?topList=striver-sde-sheet-problems&utm_source=striver&utm_medium=website",
        Platform: "codingninjas",
      },
      {
        Topic: "Heap",
        Problem: "Kth Largest Element",
        Done: false,
        URL: "https://leetcode.com/problems/kth-largest-element-in-an-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Heap",
        Problem: "Maximum Sum Combination",
        Done: false,
        URL: "https://www.interviewbit.com/problems/maximum-sum-combinations/",
        Platform: "Interviewbit",
      },
      {
        Topic: "Heap",
        Problem: "Find Median from Data Stream",
        Done: false,
        URL: "https://leetcode.com/problems/find-median-from-data-stream/",
        Platform: "leetcode",
      },
      {
        Topic: "Heap",
        Problem: "Merge K sorted arrays",
        Done: false,
        URL: "https://www.codingninjas.com/codestudio/problems/merge-k-sorted-arrays_975379",
        Platform: "codingninjas",
      },
      {
        Topic: "Heap",
        Problem: "K most frequent elements",
        Done: false,
        URL: "https://leetcode.com/problems/top-k-frequent-elements/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "Graph",
    position: 10,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Graph",
        Problem: "Clone a graph (Not that easy as it looks)",
        Done: false,
        URL: "https://leetcode.com/problems/clone-graph/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "DFS",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/depth-first-traversal-for-a-graph/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "BFS",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Detect A cycle in Undirected Graph using BFS",
        Done: false,
        URL: "https://leetcode.com/problems/course-schedule/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Detect A cycle in Undirected Graph using DFS",
        Done: false,
        URL: "https://bit.ly/3npFdrn",
        Platform: "codingninjas",
      },
      {
        Topic: "Graph",
        Problem: "Detect A cycle in a Directed Graph using DFS",
        Done: false,
        URL: "https://bit.ly/3FrzaZp",
        Platform: "codingninjas",
      },
      {
        Topic: "Graph",
        Problem: "Detect A cycle in a Directed Graph using BFS",
        Done: false,
        URL: "https://bit.ly/3FrzaZp",
        Platform: "codingninjas",
      },
      {
        Topic: "Graph",
        Problem: "Topological Sort BFS",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/topological-sort/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Topological Sort DFS",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/topological-sort/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Number of islands(Do in Grid and Graph Both)",
        Done: false,
        URL: "https://leetcode.com/problems/number-of-islands/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Bipartite Check using BFS",
        Done: false,
        URL: "https://leetcode.com/problems/is-graph-bipartite/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Bipartite Check using DFS	",
        Done: false,
        URL: "https://bit.ly/3tps98W",
        Platform: "codingninjas",
      },
      {
        Topic: "Graph",
        Problem: "Strongly Connected Component(using KosaRaju’s algo)",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-number-of-non-overlapping-substrings/discuss/766485/kosaraju-algorithm-on",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Dijkstra’s Algorithm",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/implementing-dijkstra-set-1-adjacency-matrix/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Bellman-Ford Algo",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/distance-from-the-source-bellman-ford-algorithm/0/?fbclid=IwAR2_lL0T84DnciLyzMTQuVTMBOi82nTWNLuXjUgahnrtBgkphKiYk6xcyJU",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Floyd Warshall Algorithm",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall2042/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "MST using Prim’s Algo",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/minimum-spanning-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "MST using Kruskal’s Algo",
        Done: false,
        URL: "https://bit.ly/3I1VqL9",
        Platform: "codingninjas",
      },
    ],
  },
  {
    topicName: "Trie",
    position: 11,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Trie",
        Problem: "Implement Trie (Prefix Tree)",
        Done: false,
        URL: "https://leetcode.com/problems/implement-trie-prefix-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Trie",
        Problem: "Implement Trie – 2 (Prefix Tree)",
        Done: false,
        URL: "https://bit.ly/3qwT4OL",
        Platform: "codingninjas",
      },
      {
        Topic: "Trie",
        Problem: "Longest String with All Prefixes",
        Done: false,
        URL: "https://bit.ly/3n3kedU",
        Platform: "codingninjas",
      },
      {
        Topic: "Trie",
        Problem: "Number of Distinct Substrings in a String",
        Done: false,
        URL: "https://bit.ly/3ocRQW0",
        Platform: "codingninjas",
      },
      {
        Topic: "Trie",
        Problem: "Power Set (this is very important)",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/power-set4302/1#",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Maximum XOR of two numbers in an array",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-xor-of-two-numbers-in-an-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Trie",
        Problem: "Maximum XOR With an Element From Array",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-xor-with-an-element-from-array/",
        Platform: "leetcode",
      },
    ],
  },
  {
    topicName: "Dynamic Programming",
    position: 12,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Dynamic Programming",
        Problem: "Max Product Subarray",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-product-subarray/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest Increasing Subsequence",
        Done: false,
        URL: "https://leetcode.com/problems/longest-increasing-subsequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest Common Subsequence",
        Done: false,
        URL: "https://leetcode.com/problems/longest-common-subsequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "0-1 Knapsack",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem0945/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Edit Distance",
        Done: false,
        URL: "https://leetcode.com/problems/edit-distance/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum sum increasing subsequence",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Matrix Chain Multiplication",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/matrix-chain-multiplication0303/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem:
          "Minimum sum path in the matrix, (count paths and similar type do, also backtrack to find the Minimum path)",
        Done: false,
        URL: "https://leetcode.com/problems/minimum-path-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Coin change",
        Done: false,
        URL: "https://leetcode.com/problems/coin-change/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Subset Sum",
        Done: false,
        URL: "https://leetcode.com/problems/partition-equal-subset-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Rod Cutting",
        Done: false,
        URL: "https://leetcode.com/problems/minimum-cost-to-cut-a-stick/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Egg Dropping",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Word Break",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/word-break1352/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Palindrome Partitioning (MCM Variation)",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum profit in Job scheduling",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/job-sequencing-problem-1587115620/1",
        Platform: "geeksforgeeks",
      },
    ],
  },
];

export default striverData;
